import { useEffect, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'

import { ROUTE_CONSTANTS } from 'utils/constants/routeConstants'
import { verifySignature } from 'services/apiAuth'
import { successLogin } from '../../../redux/auth/actions'

const SignatureVerification = ({ location, history }) => {
  const params = new URLSearchParams(location.search)
  const dispatch = useDispatch()

  if (!params.has('signature')) {
    history.replace({
      pathname: '/forbidden',
      state: { error: 'Link inválido!' },
    })
    return null
  }

  const verifySignatureAndRedirect = useCallback(async (signature) => {
    try {
      const response = await verifySignature({ signature })
      const { data, status } = response

      if (status === 200 && data) {
        dispatch(successLogin({ ...data }))
        history.replace({
          pathname: ROUTE_CONSTANTS.PASSWORD_REDEFINE,
        })
      } else {
        toast.error('Assinatura inválida ou expirada. Você será redirecionado ao login em breve.')
      }
    } catch (error) {
      let state
      if (error.response) {
        state = {
          error: error.response.data.detail,
          redirect: error.response.data.redirect_url,
        }
      } else {
        state = {
          error: 'Houve um problema na requisição.',
        }
      }

      history.replace({
        pathname: '/forbidden',
        state,
      })
    }
  }, [dispatch, history])

  useEffect(() => {
    verifySignatureAndRedirect(params.get('signature')).catch((error) => {
      console.error('An error occurred:', error)
    })
  }, [params, verifySignatureAndRedirect])

  return null
}

export default SignatureVerification
